import React from "react";
import { ThemeProviderWrapper } from "./context/ThemeContext";
import AppRoutes from "./routes";
import "./i18n"; // Import hệ thống đa ngôn ngữ

function App() {
  return (
    <ThemeProviderWrapper>
      <AppRoutes />
    </ThemeProviderWrapper>
  );
}

export default App;
